import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelDParticipantCompetencyPointsResponse, LevelDReportFilter } from "../../types/leveld-reports";

interface UseGetLevelDParticipantCompetencyPointsParams {
  filter: LevelDReportFilter;
  enabled?: boolean;
}

export const useGetLevelDParticipantCompetencyPoints = ({
  filter,
  enabled = true,
}: UseGetLevelDParticipantCompetencyPointsParams) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchParticipantCompetencyPoints = async (): Promise<LevelDParticipantCompetencyPointsResponse> => {
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      if (filter.examTermId) {
        params.append('examTermId', filter.examTermId);
      }

      const { data } = await axios.get(`/api/leveldreports/participant-competency-points?${params.toString()}`);
      return data;
    } catch (error) {
      throw new Error(t("levelDReports.errors.getParticipantCompetencyPoints"));
    }
  };

  return useQuery({
    queryKey: ["levelDParticipantCompetencyPoints", filter],
    queryFn: fetchParticipantCompetencyPoints,
    enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate) && Boolean(filter.examTermId),
  });
};
